import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from 'src/components/editor/EditTracking';

const RatingAnswerSurveyTracking_0202: FC = () => {
  const dispatch = useDispatch();

  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    .root_tracking {
      background: none;

      .close {
        width: 100%;
      }

      .center_wrapper {
        width: 100%;
      }

      .cta_button button {
        justify-content: end;
        background: transparent;
      }

      .bottom button {
        background: none;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view root_view_0202 root_tracking">
        <div className="template">
          <div className="center_horizon close tracking_center">
            <EditTracking
              value={tracking?.close_0202?.[currentIndex]}
              type="close_0202"
            />
          </div>
          <div className="center_wrapper">
            <div className="logo"></div>
            <div className="title"></div>
            <div className="sub_title"></div>
            <div className="star_wrapper"></div>
            <div className="cta_button">
              <button className="button tracking_center">
                <EditTracking
                  value={tracking?.cta_button_0202?.[currentIndex]}
                  type="cta_button_0202"
                />
              </button>
            </div>
          </div>
          <div className="center_horizon bottom">
            <button className="button tracking_center">
              <EditTracking
                value={tracking?.button_0202?.[currentIndex]}
                type="button_0202"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RatingAnswerSurveyTracking_0202;
